import { BaseEntity } from "./BaseEntity";

export class ManageFavoritesEntity extends BaseEntity {
    constructor() {
        super();

        this.entityName = "common.labels.manageFavorites";
        this.pageTitle =  this.entityName;
        this.menuPath = "";
        this.APIRoute = ""
        this.i18nBase = "";
        this.baseEndPoint = "";
        this.endpoints = {
            list: `${this.baseEndPoint}`,
        };



        this.pages = {
            list: {
                pageTitle:  this.entityName,
                route: ["/"],
            },
        };
    }

    getUrl(endpoint, params = {}) {
        let url = endpoint;
        Object.keys(params).forEach(key => {
            url = url.replace(`:${key}`, params[key]);
        });
        return url;
    }
}
